module.exports = __webpack_public_path__ + "img/DOWNLOAD.aec94d79.svg";